const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');
const BattleCalc = require('../../BattleCalc');
const Q_which_ranged_attack = require('./Q_which_ranged_attack');

const Q_target_high_hp = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.YES = 'yes';
  node.NO = 'no';

  node.voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  node.arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  node.multiShot = BattleCalc.getEquippedAbility(actor, 'multi_shot');
  node.razorShot = BattleCalc.getEquippedAbility(actor, 'razor_shot');
  node.infectMind = BattleCalc.getEquippedAbility(actor, 'infect_mind');
  node.fumigate = BattleCalc.getEquippedAbility(actor, 'fumigate');
  node.lightning = BattleCalc.getEquippedAbility(actor, 'lightning');
  node.molotov = BattleCalc.getEquippedAbility(actor, 'molotov_cocktail');

  node.branches[node.NO] = new Q_which_ranged_attack(actor, battleState);

  const originalDispose = node.dispose;
  node.dispose = function () {
    node.voidSpike = null;
    node.arrowShot = null;
    node.multiShot = null;
    node.razorShot = null;
    node.infectMind = null;
    node.fumigate = null;
    node.lightning = null;
    node.molotov = null;
    node.sortedAbilities = null;
    node.abilityChain = null;
    originalDispose.call(node);
  };

  node.buildAbilityChain = function () {
    const DAMAGE_DICT = {
      void_spike: node.voidSpike ? node.voidSpike.damage : 0,
      arrow_shot: node.arrowShot ? node.arrowShot.damage : 0,
      razor_shot: node.razorShot ? node.razorShot.potency : 0,
      multi_shot: node.multiShot ? node.multiShot.damage : 0,
      infect_mind: node.infectMind ? node.infectMind.potency : 0,
      fumigate: node.fumigate ? node.fumigate.potency : 0,
      lightning: node.lightning ? node.lightning.damage : 0,
      molotov_cocktail: node.molotov ? node.molotov.damage : 0,
    };

    // Sort abilities by damage in descending order
    const sortedAbilities = Object.entries(DAMAGE_DICT)
      .filter(([handle, damage]) => 
        BattleCalc.getEquippedAbility(actor, handle) && damage > 0
      )
      .sort((a, b) => b[1] - a[1])
      .map(([handle]) => handle);

    node.sortedAbilities = sortedAbilities;

    // Build chain of UseAbility instances in reverse order
    if (sortedAbilities.length === 0) {
      node.abilityChain = null;
      return;
    }

    let chain = node.branches[node.NO];
    for (let i = sortedAbilities.length - 1; i >= 0; i--) {
      const handle = sortedAbilities[i];
      chain = new UseAbility({
        actor,
        abilityHandle: handle,
        altNode: chain,
      });
    }

    node.abilityChain = chain;
  };

  node.buildAbilityChain();

  node.query = function (target) {
    if (!node.abilityChain || !node.yesNoEvalFunction(target)) {
      return node.branches[node.NO].query(target);
    }

    // For ranged bleeds, try to spread DoTs to non-bleeding targets before applying new stacks
    if (!!(node.razorShot || node.infectMind || node.fumigate)) {
      target = AICalc.getBestDoTTarget(actor, target, battleState);
    }

    // Check if fumigate is safe (if it's in the chain)
    if (node.sortedAbilities.includes('fumigate')) {
      if (!AICalc.isAoESafe(actor, 'fumigate', actor, battleState, 1.5)) {
        // Rebuild chain without fumigate
        const filteredAbilities = node.sortedAbilities.filter(h => h !== 'fumigate');
        let chain = node.branches[node.NO];
        for (let i = filteredAbilities.length - 1; i >= 0; i--) {
          chain = new UseAbility({
            actor,
            abilityHandle: filteredAbilities[i],
            altNode: chain,
          });
        }
        return chain.query(filteredAbilities.includes('fumigate') ? actor : target);
      }
    }

    return node.abilityChain.query(
      node.sortedAbilities[0] === 'fumigate' ? actor : target
    );
  };

  node.yesNoEvalFunction = function (target) {
    const dot_potency = BattleCalc.getCombinedDoTPotency(target);
    if (dot_potency > target.hp * 0.333) return false;
    if (!node.sortedAbilities || node.sortedAbilities.length === 0) return false;
    
    // Get top damage from first ability in sorted list
    const topAbilityHandle = node.sortedAbilities[0];
    const topAbility = BattleCalc.getEquippedAbility(actor, topAbilityHandle);
    const topDamage = topAbility ? (topAbility.damage || topAbility.potency || 0) : 0;
    
    return target.hp > topDamage * 2.5;
  };

  return node;
};
module.exports = Q_target_high_hp;
